import React, {useEffect} from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { profile } from '../../config/profile'

export default function About() {
    useEffect(() => {
        AOS.init({duration:1000})
    }, [])

    // Split bio into bullet points
    const bioPoints = profile.bio.split('\n').filter(point => point.trim());
    
    return (
        <section className="about-area page-section scroll-to-page" id="about">
            <div className="custom-container">
                <div className="about-content content-width">
                    <div className="section-header">
                        <h4 className="subtitle scroll-animation" data-aos='fade-up'>
                            <i className="lar la-user"></i> about
                        </h4>
                        <h1 className="scroll-animation" data-aos='fade-up'>Professional <span>Summary</span></h1>
                    </div>

                    <div className="about-details scroll-animation" data-aos='fade-up'>
                        {bioPoints.map((point, index) => (
                            point.trim() && (
                                <div key={index} className="about-info">
                                    <p className="bio-point">{point}</p>
                                </div>
                            )
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}
